import { Component, OnDestroy, OnInit } from '@angular/core';
import { DetailViewNotifyService } from '../../shared/detailview-notify.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { DetailViewComponent } from '../../detail-view.component';

// Select control
@Component({
    selector: 'select-box',
    templateUrl: './select-box.component.html',
    styleUrls: ['./select-box.component.scss'],
    standalone: false
})
export class SelectBoxComponent extends BaseControlComponent implements OnInit, OnDestroy {
  constructor(
    public translate: TranslateService,
    public detailViewNotifyService: DetailViewNotifyService,
    public detailViewComponent: DetailViewComponent
  ) {
    super(detailViewNotifyService, translate);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onChange(event): void {
    if (this.prop.field_name === 'VERKAUFSOBJEKTART') {
      this.detailViewNotifyService.onSetTransObjektArtSubject.next((event.target.value));
    }
  }
}
